var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 25.333h6a.667.667 0 010 1.334H6.001A.666.666 0 015.334 26V8.667a.654.654 0 01.196-.472l5.332-5.332a.653.653 0 01.215-.144.652.652 0 01.257-.052h14.667c.368 0 .666.297.666.666v9.334a.667.667 0 01-1.333 0V4H12.001v4.667a.667.667 0 01-.667.666H6.667v16zm4-20.39L7.61 8h3.057V4.943zm18.863 19.25a.666.666 0 11.941.946l-6.708 6.666a.667.667 0 01-.941 0l-6.708-6.666a.666.666 0 11.94-.946l5.613 5.579V16.667a.666.666 0 111.334 0v13.022l5.529-5.496zM13.14 13.547a.732.732 0 00-1.033 0l-3.892 3.877a.729.729 0 00.516 1.243H19.27a.731.731 0 00.675-.45.725.725 0 00-.159-.793l-3.233-3.223a.732.732 0 00-1.032 0l-.862.859-1.52-1.513zm4.194-2.88a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0z",
    fill: "#848999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.55d14fa034f9e56186c5f9f17fe2d976.svg";
export { ForwardRef as ReactComponent };